import { useAuth } from "../contexts/AuthContext";
import { Navigate, useLocation } from "react-router-dom";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500 text-sm">
        Loading...
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" state={{ from: loc }} replace />;
  if (roles && !roles.includes(user.role)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="max-w-md text-center">
          <div className="overline mb-2">403 Forbidden</div>
          <h2 className="text-2xl font-semibold mb-2">Access denied</h2>
          <p className="text-slate-500 text-sm">
            Your role ({user.role}) cannot access this page.
          </p>
        </div>
      </div>
    );
  }
  return children;
}
